module.exports = __webpack_public_path__ + "static/section-five-4c103c1336d43d960a4c70618d2935a0.png";